import SettingHistory from "./components/SettingHistory";

const index = () => {
  return <SettingHistory />;
};

export default index;
